// reducers.js
import userProfileReducer from './slices/userProfile';
import carDataReducer from './slices/mapSearch';
import snackbarReducer from './slices/snackbar';

const allReducers = {
  user: userProfileReducer,
  carDataReducer,
  snackbar: snackbarReducer,
};

export default allReducers;
